import { useEffect, useRef, useState } from "react";
import Bottleneck from "bottleneck";
import { useDispatch, useSelector } from "react-redux";
import { uploadChunkGuestApi } from "../../../services/api";
//import useUpload from "../hooks/use";
import { uploadChunkApi } from "../../../services/api";
import useUploadActions from '../useUploadActions';
import { determineFileType } from '../commonServices';
import { removeExtension, showSnackBar } from '../../../utils/commonServices';
import { uploadCategory } from "../../../constants/constants";
import { chunkFailureStatus, isNonRetryableChunkFailure, REVISION_ERROR_CODE } from "../../../utils/revisionContent";
import { resetUploadState, setUploadState } from "../../../redux/uploadSlice";
import useUploadedList from "../../../hooks/useUploadedList";
import { getAllEventNotes, getAllEventSongs } from "../../events/actions";
import { getAllAssets } from "../../brandbox/actions";
import { addAbortController, removeAbortController } from "../abortManager";

export default () => {
  const commonReducer = useSelector((state) => state.root.commonReducer);
  const {getEventMediaFiles} = useUploadedList(!!commonReducer.production_event_id);
  const [progress, setProgress] = useState([]);
  const [chunkProgress, setChunkProgress] = useState(0);
  const [requestController, setRequestController] = useState([]);
  const [uploadStatus, setUploadStatus] = useState([]);
  const [imgSrc, setImgSrc] = useState([]);
  const [files, setFiles] = useState([]);
  const [selectedFiles, setSelectedFiles] = useState([])
  const [uploadsInProgress, setUploadsInProgress] = useState([]);

  const [isLoading, setIsloading] = useState(false);
  const initialUploadState =()=>{
    syncFilesRef([])
    syncProgressRef([])
    syncStatusRef([])
    controllerRef.current=[]
    setProgress([])
    setRequestController([])
    setUploadStatus([])
    setImgSrc([])
    setUploadsInProgress([])
    setIsloading(false)
    setFiles([])
    setSelectedFiles([])
    dispatch(setUploadState({uploading_file_index:null}))
  }


  const uploadReducer = useSelector((state) => state.root.uploadReducer);
  const dispatch = useDispatch();
  const maxSizeGb = 10;
  const { fileUploadPreflight, fileUploadPostflight } = useUploadActions();
  const filesRef = useRef([]); // Mutable reference to the files array
  const progressRef = useRef([])
  const controllerRef = useRef([]);
  const statusRef = useRef();
  const abortAllRef = useRef(false);

  // Sync the filesRef whenever the files array changes
  const syncFilesRef = (newFiles) => {
    filesRef.current = newFiles;
  };

  const syncProgressRef = (newArray) => {
    progressRef.current = newArray;
  };
  const syncControllerRef = (newArray) => {
    controllerRef.current = newArray;
  };

  const syncStatusRef = (newArray) => {
    statusRef.current = newArray;
  };
  const syncAbortAllRef = (newValue) => {
    abortAllRef.current = newValue;
  };

  //Callback to grab a function from child components to be executed here after api calls



  // Returned by uploadChunkWithRetry when the server says the file is already
  // stored (409 upload_completed) - a soft outcome, not a failure.
  const ALREADY_UPLOADED = 'already_uploaded';

  // Initialize Bottleneck for sequential chunk uploads
  const chunkLimiter = new Bottleneck({
    maxConcurrent: 1,
    minTime: 200, // Adjust based on your API rate limits
  });

  const fileLimiter = new Bottleneck({
    maxConcurrent: 1,
    minTime: 200, // Adjust based on your API rate limits
  });

  const getRefetchFunction = (category) => {
    // console.log('post flight refetch function.............................', category)
    switch (category) {
      case uploadCategory.assets:
        return getAllAssets(dispatch);

      case uploadCategory.media:
        return getEventMediaFiles({id: commonReducer?.production_event_id});

      case uploadCategory.notes:
        return getAllEventNotes({ event_id: commonReducer?.production_event_id }, dispatch);

      case uploadCategory.songs:
        return getAllEventSongs({ event_id: commonReducer?.production_event_id }, dispatch);

      default:
        return 'No action';
    }
  };

  // console.log(chunkProgress , 'chunk upload loop...............................................................')

  const updateStatus = (fileIndex, newStatus) => {
    // Always use the ref as source since it's synchronous and up-to-date
    const tempStatus = (statusRef.current || [])?.map((status_item, status_index) => {
      if (status_index == fileIndex) {
        return newStatus
      } else {
        return status_item;
      }
    })
    console.log("Temp status-------------------------------------------------->>>>>>", statusRef.current)
    dispatch(setUploadState({ upload_status: tempStatus }));
    syncStatusRef(tempStatus);
    setUploadStatus(tempStatus); // Keep local state in sync so it can be used as source of truth when new files are added
  }

  // Function to simulate chunk upload
  const uploadChunk = async (media_id, chunkData, fileIndex, updateProgress, abortController, isGuest) => {
    dispatch(setUploadState({ uploading_file_index: fileIndex }));
    if(abortAllRef.current){
      return;
    }
     
    const payload = chunkData;
    const controller = new AbortController();
    addAbortController(fileIndex, controller);
    const apiOptions = {
      data: payload,
      progress: updateProgress,
      headers: { "Content-Type": "multipart/form-data" }, // Correct header format
      controller: controller
    }

    try {
      const response = isGuest ? await uploadChunkGuestApi(apiOptions) : await uploadChunkApi(apiOptions);
      // console.log(`Chunk ${chunkIndex} uploaded successfully.`, response?.data);
      // 
      if (response?.data?.message === 'Chunk uploaded successfully') {
        // console.log(`Chunk ${chunkIndex} uploaded successfully.`, response?.data);
        //  setChunkProgress(0)
        // Remove controller on success
        removeAbortController(fileIndex);
        return { status: "success", data: response?.data };  // Indicate success
      } else {
        throw new Error(`Server responded with status`);
      }

    } catch (error) {
      // setChunkProgress(0);
      console.error(`Error uploading chunk ${chunkData.data.index}:`, error.message);

      // The HTTP status and the server's `error_code` decide whether this chunk
      // may be retried at all, so neither may be dropped here - the message
      // alone cannot tell "storage hiccup, try again" from "the revision closed".
      return {
        status: "error",
        data: error.message,
        httpStatus: error?.response?.status,
        errorCode: error?.response?.data?.error_code,
        // The server's own message, not axios's. isNonRetryableChunkFailure
        // reads it to spot "Invalid chunk index", and it is what gets shown
        // against the file when the server wrote something for the user.
        message: error?.response?.data?.message,
      };
    }
  };


  const uploadChunkWithRetry = async (fileId, chunk, fileIndex, updateProgress, abortController, isGuest, maxRetries = 5, delay = 1000) => {
    for (let attempt = 1; attempt <= maxRetries; attempt++) {
      if(abortAllRef.current)
      return;
      try {
        // Attempt to upload the chunk
        const response = await uploadChunk(fileId, chunk, fileIndex, updateProgress, abortController, isGuest);

        console.log("rsponse>>>>>>>>>>>>>>>>", response)
        // Check for a successful response
        if (response.status == 'success') {
          console.log(`Chunk ${chunk.data.index} uploaded successfully on attempt ${attempt}.`);
          return true;  // Exit function on success
        }

        // The file is already stored server-side. Not a failure: stop sending
        // chunks for it and let post_flight (or the next list refresh) finish.
        if (response?.errorCode === REVISION_ERROR_CODE.UPLOAD_COMPLETED) {
          console.log(`Chunk ${chunk.data.index}: file already uploaded, skipping remaining chunks.`);
          return ALREADY_UPLOADED;
        }

        // A coded refusal or a 403/404/413/415 will answer the same way every
        // time, so waiting and resending only delays the message to the user.
        if (isNonRetryableChunkFailure(response)) {
          updateStatus(fileIndex, { type: "error", message: chunkFailureStatus(response) });
          // The upload list is cleared shortly after the queue ends, taking the
          // row's status with it. A revision file that was not added must still
          // be told to the user, so it is repeated where it stays on screen.
          if (chunk?.category === uploadCategory.revisionContent) {
            showSnackBar(dispatch, {
              http_code: response?.httpStatus,
              message: `${chunk?.data?.filename ? `${chunk.data.filename.replace(/_\d+$/, '')}: ` : ''}${response?.message || chunkFailureStatus(response)}`,
            });
          }
          return false;
        }

        throw new Error(response.data);

      } catch (error) {
        // console.error(`Error uploading chunk ${chunk.data.index}, attempt ${attempt}:`, error.message);
        console.log("error", error)
        if (error.message == "canceled") {
          console.log("here")
          updateStatus(fileIndex, { type: "error", message: "Canceled!" })
          return false
        }
        // Wait before retrying
        if (attempt < maxRetries) {
          await new Promise(resolve => setTimeout(resolve, delay * attempt));  // Exponential backoff
        } else {
          console.error(`Chunk ${chunk.data.index} failed after ${maxRetries} attempts.`);
          updateStatus(fileIndex, { type: "error", message: "Upload Failed!!" })
          return false;  // Final failure after retries
        }
      }
    }
  };


  // DEV TESTING ONLY: 1-based chunk indices to skip on the first upload pass to simulate
  // a backend 422 "chunk mismatch" response. Set to [] to disable.
  const DEV_SKIP_CHUNK_INDICES = process.env.NODE_ENV === 'development' ? [2, 4] : [];

  // Function to handle file processing
  const processFileUpload = async (file, fileIndex) => {
    if(uploadReducer.upload_status[fileIndex]?.message == "File already exists") {
      console.log("already exists")
      throw new Error(`file_exists`);
    }

    const chunkSize = 1024 * 1024 * 10; // 10 MB chunk size
    const totalChunks = Math.ceil(file.size / chunkSize);
    const fileType = determineFileType(file);
    const isRevisionContent = file.category === uploadCategory.revisionContent;
    const preFlightPayload = {
      data: {
        name: file?.name,
        // RevisionContent derives the type from the extension server-side and
        // answers 422 type_mismatch when a disagreeing content_type is sent.
        // determineFileType reads the browser's MIME category, which disagrees
        // for several listed extensions (.ogg is reported as video/ogg but is
        // an audio type), so this category sends no content_type at all.
        ...(isRevisionContent ? {} : { content_type: fileType }),
        size: file?.size,
        total_chunk_count: totalChunks,
        ...file.extraPayload
      },
      category: file.category,
    };

    let media_id;
    try {
      media_id = await fileUploadPreflight(preFlightPayload, file.isGuest);
    } catch (preFlightError) {
      // pre_flight carries the reason the file was refused - a blocked or
      // unsupported extension, a revision that closed, a permission the user
      // does not have. Showing the server's own message is the whole point of
      // the coded errors; a generic "Upload Failed" would hide it.
      const errorData = preFlightError?.response?.data;
      const message = errorData?.message;
      updateStatus(fileIndex, { type: "error", message: message || "Upload Failed!!" });
      if (message) showSnackBar(dispatch, { http_code: errorData?.http_code || preFlightError?.response?.status, message });
      throw preFlightError;
    }
    if (!media_id) return;

    // Uploads a set of chunks for this file.
    // chunkIndicesToUpload: array of 1-based indices to upload, or null to upload all.
    // isRetryPass: true when re-uploading only missing chunks (disables dev skip).
    const uploadChunkSet = async (chunkIndicesToUpload, isRetryPass) => {
      let successCounter = 0;
      let tempFileProgress = 0;
      // Set when the server reports the file is already stored, so the loop can
      // stop without the remaining chunks counting as failures.
      let alreadyUploaded = false;

      for (let i = 1; i <= totalChunks; i++) {
        // Skip chunks not in the requested subset (count as already complete)
        if (chunkIndicesToUpload !== null && !chunkIndicesToUpload.includes(i)) {
          successCounter++;
          continue;
        }

        // DEV TESTING ONLY: skip certain chunks on first pass to simulate missing chunks at backend
        if (!isRetryPass && DEV_SKIP_CHUNK_INDICES.includes(i)) {
          console.warn(`[DEV] Skipping chunk ${i} to simulate missing chunk on backend`);
          successCounter++;
          continue;
        }

        const updateFileProgress = (tempProgress) => {
          tempFileProgress = parseFloat((i - 1) / totalChunks) * 100.0 + parseFloat(tempProgress / totalChunks);
          const temp = progressRef.current?.map((num, index) => {
            if (fileIndex == index) return tempFileProgress;
            return num;
          });
          dispatch(setUploadState({ progress: temp }));
        };

        const start = (i - 1) * chunkSize;
        const end = Math.min(file.size, start + chunkSize);
        const chunk = file.slice(start, end);

        const payloadData = {
          data: {
            file: chunk,
            index: i,
            filename: `${removeExtension(file?.name)}_${i}`,
            size: chunk?.size,
            id: media_id,
            // A guest is refused (403) on every call without BOTH of these -
            // the guest id alone is never enough.
            ...(file.isGuest && file.extraPayload?.guest_user_id && { guest_user_id: file.extraPayload.guest_user_id }),
            ...(file.isGuest && file.extraPayload?.collab_code && { collab_code: file.extraPayload.collab_code })
          },
          category: file.category
        };

        const abortController = controllerRef.current[fileIndex];
        console.log("abort controller...................>>>>>>>>>>>", controllerRef.current);

        const success = await chunkLimiter.schedule(() =>
          uploadChunkWithRetry(media_id, payloadData, fileIndex, updateFileProgress, abortController, file.isGuest)
        );

        if (success === ALREADY_UPLOADED) {
          alreadyUploaded = true;
          break;
        } else if (success) {
          successCounter++;
        } else {
          throw new Error(`Failed to upload chunk ${i}, stopping file upload.`);
        }
      }

      return alreadyUploaded || successCounter === totalChunks;
    };

    const postFlightPayload = {
      data: {
        id: media_id,
        ...(file.isGuest && file.extraPayload?.guest_user_id && { guest_user_id: file.extraPayload.guest_user_id }),
        ...(file.isGuest && file.extraPayload?.collab_code && { collab_code: file.extraPayload.collab_code })
      },
      category: file.category
    };

    const postFlightCallback = (progress) => {
      setChunkProgress(progress);
      if (!(!!file.isGuest || ((file.category == uploadCategory.media) && !commonReducer.production_event_id))) {
        getRefetchFunction(file.category);
      }
      if (file.category === uploadCategory.revisionContent) {
        // The revision-content list is owned by the review page (and by the
        // guest page, which has no refetch wired here at all), so the finished
        // file is announced rather than fetched: whoever is showing the list
        // reloads it. A bump, not a boolean, so consecutive files each land.
        dispatch(setUploadState({ revision_content_refresh: Date.now() }));
      }
      updateStatus(fileIndex, { type: "success", message: "Uploaded Successfully!" });
      if (fileIndex === files.length - 1) {
        setIsloading(false);
      }
    };

    // First pass: upload all chunks
    const allSuccess = await uploadChunkSet(null, false);

    if (!allSuccess) {
      updateStatus(fileIndex, { type: "error", message: "Upload Failed!" });
      console.log("Few parts of file are missing. try to re upload");
      return;
    }

    if (abortAllRef.current) return;

    // Postflight with up to 2 chunk-retry attempts (3 total postflight calls: 1 original + 2 after failed postflights)
    const MAX_POSTFLIGHT_ATTEMPTS = 3;

    for (let attempt = 1; attempt <= MAX_POSTFLIGHT_ATTEMPTS; attempt++) {
      if (abortAllRef.current) return;
      try {
        await fileUploadPostflight(postFlightPayload, file.isGuest, postFlightCallback);
        break; // postflight succeeded — stop the loop
      } catch (postFlightError) {
        // Every part arrived but the sizes did not add up; the server aborted
        // the upload. The file has to start again from pre_flight, so there is
        // nothing here to retry.
        if (postFlightError?.type === 'UPLOAD_CORRUPT') {
          updateStatus(fileIndex, { type: "error", message: chunkFailureStatus({ errorCode: REVISION_ERROR_CODE.UPLOAD_CORRUPT }) });
          showSnackBar(dispatch, { http_code: 409, message: postFlightError?.message });
          break;
        }

        // Storage hiccup: the chunks are intact, only the finish needs repeating.
        if (postFlightError?.type === 'RETRY_POSTFLIGHT' && attempt < MAX_POSTFLIGHT_ATTEMPTS) {
          updateStatus(fileIndex, { type: "error", message: "Finishing upload — retrying…" });
          await new Promise((resolve) => setTimeout(resolve, 1500 * attempt));
          continue; // same chunks, another post_flight
        }

        if (postFlightError?.type === 'STOP_FILE' || postFlightError?.type === 'RETRY_POSTFLIGHT') {
          updateStatus(fileIndex, { type: "error", message: chunkFailureStatus(postFlightError) });
          if (postFlightError?.message) showSnackBar(dispatch, { http_code: postFlightError?.httpStatus, message: postFlightError.message });
          break;
        }

        if (postFlightError?.type === 'MISSING_CHUNKS' && attempt < MAX_POSTFLIGHT_ATTEMPTS) {
          const missing = postFlightError.missing_chunk_indices;
          console.log(`[Upload] Postflight attempt ${attempt} reported missing chunks: [${missing.join(', ')}]. Starting re-upload attempt ${attempt + 1}...`);
          updateStatus(fileIndex, { type: "error", message: `Error uploading! Re-upload attempt ${attempt + 1} ...` });

          try {
            const retrySuccess = await uploadChunkSet(missing, true);
            if (!retrySuccess) {
              updateStatus(fileIndex, { type: "error", message: "Chunk retry failed!" });
              return;
            }
          } catch (retryChunkError) {
            console.error('[Upload] Retry chunk upload error:', retryChunkError);
            updateStatus(fileIndex, { type: "error", message: "Upload failed during chunk retry!" });
            return;
          }
          // continue loop → next postflight attempt
        } else {
          if (postFlightError?.type === 'MISSING_CHUNKS') {
            console.error('[Upload] Postflight failed after all 3 attempts.');
            updateStatus(fileIndex, { type: "error", message: "Upload failed after all retry attempts!" });
          } else {
            console.error('[Upload] Postflight error:', postFlightError);
            updateStatus(fileIndex, { type: "error", message: "Upload Failed!" });
          }
          break; // proceed to next file in the list
        }
      }
    }
  };

  // Main function to handle multiple files
  const uploadFiles = async () => {
    // dispatch(setUploadState({ upload_list_drawer: true }))
    setIsloading(true)
    for (let index = 0; index < filesRef.current.length; index++) {
      const file = filesRef.current[index];
      let tempUploads = [];

      // Add file to uploads-in-progress state
      setUploadsInProgress((prev) => {
        if (!prev.includes(file.name)) {
          tempUploads = [...prev, file.name];
        } else {
          tempUploads = prev;
        }
        return tempUploads;
      });

      // Dispatch to Redux
      dispatch(
        setUploadState({
          is_loading: true,
          in_progress_files: tempUploads, // Directly pass the array for Redux
        })
      );

      try {
        if (!uploadsInProgress.includes(file.name)) {
          const tempTotalProgress =
            (index / filesRef.current.length) * 100 +
            uploadReducer.file_progress / filesRef.current.length;

          dispatch(
            setUploadState({ total_progress: tempTotalProgress })
          );
         
          await processFileUpload(file, index);
        }
      } catch (error) {
        console.log({error})
        
       // console.error(`Error uploading file ${file.name}:`, error);
      }
    }

    // Reset upload state after a delay
    setTimeout(() => {
       
      //  controllerRef.current=[]
       dispatch(resetUploadState());
     
     //  initialUploadState()
       
    }, 1500);
  };

  // useEffect(()=> {
  //   return () => {
  //     syncFilesRef([])
  //     syncProgressRef([])
  //     syncStatusRef([])
  //     controllerRef.current=[]
  //     initialUploadState()
  //   }

  // }, [])

  useEffect(() => {
    syncProgressRef(progress)
  }, [progress])

  useEffect(() => {
    syncStatusRef(uploadStatus)
  }, [uploadStatus])

  // Sync statusRef from Redux when drawer toggles to prevent stale state
  useEffect(() => {
    if (uploadReducer.upload_status.length > 0) {
      syncStatusRef(uploadReducer.upload_status)
    }
  }, [uploadReducer.upload_status])


  useEffect(() => {

    syncFilesRef(selectedFiles); // Sync the reference
    if (selectedFiles?.length > 0) {
      // dispatch(setUploadState({ upload_list_drawer: true }))
    }

    if (!uploadReducer.is_loading) {
      uploadFiles()
    }
    //uploadFiles()
  }, [selectedFiles]);

  useEffect(()=> {
    if(uploadReducer.abort_all) {
      // syncAbortAllRef(true)
   
      initialUploadState()
    
    }
  }, [uploadReducer.abort_all])

  return {
    files,
    setFiles,
    selectedFiles, setSelectedFiles,
    uploadsInProgress, setUploadsInProgress,
    uploadFiles,
    uploadStatus,
    setUploadStatus,
    progress,
    setProgress,
    imgSrc,
    setImgSrc,
    isLoading,
    requestController,
    setRequestController,
    initialUploadState
    //  stopUpload,
    // stopList,
  };
}
